<template>
    <div>
        <el-card>
            <card-header :title="!isEdit ? $t('customerTypesCreate') : $t('customerTypesUpdate')" />
            <form>
                <input-field :label="$t('customerTypesName')"
                        :error="error.name ? error.name[0] : ''" 
                        v-model="customerType.name"/>
                 <lang-tabs
                    typeField="textarea"
                    :inputName="$t('customerTypesDescription')" 
                    :inputKey="'description'" 
                    :inputValue="customerType.description"
                    @langData="updateLangData" 
                    :langErrors="{description: error.description ? error.description : error['description.en']}"
                />
                    <!-- <input-field 
                        :label="$t('customerTypesName')"
                        :error="error.name ? error.name[0] : ''" 
                        v-model="customerType.name"/> -->
            </form>
            <shared-buttons discardPath="CustomerTypes" :isEdit="isEdit" @confirm-event-fired="save(customerType)"/>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CardHeader from '../LayoutPart/CardHeader'
import InputField from '../Inputs/InputField'
import LangTabs from '../LangTabs/LangTabs'
export default {
    components: {
        CardHeader,
        InputField,
        LangTabs
    },
    data () {
        return  { 
            error: {},
        }
    },
    props: {
        isEdit: {
            type: Boolean
        },
        customerType: {
            isRequired: true
        }
    },
    computed: {

    },
    watch: {

    },
    created () {

    },
    methods: {
        async save (customerType) {
            let url = 'saveCustomerType'
            this.isEdit ? url = 'updateCustomerType' : 'saveCustomerType'

            await this.$store.dispatch(url, customerType)
            .then ((res) => {
                console.log('res', res);
                
                if (res === 'success') {
                    this.$router.push({name: 'CustomerTypes'})
                } else if (res.fields) {
                    this.error = res.fields
                } else if (res === 'error') {
                    this.$router.push({name: 'CustomerTypes'})
                }
            })
        },
        updateLangData (updatedData) {
            this.customerType[Object.keys(updatedData)[0]] = updatedData[Object.keys(updatedData)[0]]
        },
    }
    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/CustomerTypes/CustomerTypesForm.vue